import { GtmEvents } from '@/gtm/gtm-events';

const LABELS = {
  freeShipping: 'Бесплатная доставка',
  paidShipping: 'Платная доставка',
  bestWay: 'Лучший способ получения',
};

class TriggerNotifications extends GtmEvents {
  constructor(eventLabel) {
    super('СобытияОбщие');
    this.eventLabel = eventLabel;
  }

  onShown() {
    return this.gtmEvent({
      eventAction: 'ТриггерУведомление_Показ',
      eventLabel: JSON.stringify({ trigger: this.eventLabel }),
    });
  }

  onClose() {
    return this.gtmEvent({
      eventAction: 'ТриггерУведомление_Закрыть',
      eventLabel: JSON.stringify({ trigger: this.eventLabel }),
    });
  }
}

class FreeShippingNotification extends TriggerNotifications {
  constructor() {
    super(LABELS.freeShipping);
  }
}

class PaidShippingNotification extends TriggerNotifications {
  constructor() {
    super(LABELS.paidShipping);
  }
}

class BestWayNotification extends TriggerNotifications {
  constructor() {
    super(LABELS.bestWay);
  }
}

export const freeShippingNotification = new FreeShippingNotification();
export const paidShippingNotification = new PaidShippingNotification();
export const bestWayNotification = new BestWayNotification();
